import { all, fork, put, select, takeLatest } from "redux-saga/effects";
import actions from "../actions";
import CONSTANTS from "../CONSTANTS";
import { toast } from "react-toastify";

const COMPENSIONS_URL = "/services/rcp/profile/compensations/";
export function* getRemunerationsDashbord() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_REMUNERATIONS_DASHBOARD,
    function* (action) {
      try {
        yield put(actions.setRemunerationsDashbord(null));

        const url =
          COMPENSIONS_URL +
          "GetRemunerationsDashbord?policyId=" +
          action.payload;
        const res = yield window.mainAxios.get(url).then((r) => r.data);
        // console.log(res)
        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };
        const data = res.data;

        yield put(actions.setRemunerationsDashbord(data));
      } catch (e) {
        yield put(actions.setRemunerationsDashbord([]));
        console.error(e);
      }
    }
  );
}
export function* sendRequestReturnedMain() {
  yield takeLatest(
    CONSTANTS.GET_SEND_REQUEST_COMPESATIONS_RETURNED_MAIN,
    function* (action) {
      try {
        yield put(
          actions.setCompensationsRequestLoadingMain({
            loading: true,
            success: false,
          })
        );
        const url = `${COMPENSIONS_URL}ResubmitRemonurationShort`;
        yield put(actions.setGridSizeValidateMain(true));

        const res = yield window.mainAxios
          .post(url, action.payload.data)
          .then((x) => x.data);

        if (!res.success)
          // eslint-disable-next-line no-throw-literal

          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        yield put(actions.setGridSizeValidateMain(true));

        const lang = yield select((state) => state.common.lang);
        toast.success(
          lang === "ge"
            ? "ანაზღაურების მოთხოვნა გადაგზავნილია!"
            : "Reimbursement request sent!"
        );

        yield put(
          actions.setCompensationsRequestLoadingMain({
            loading: false,
            success: true,
          })
        );
      } catch (e) {
        yield put(
          actions.setCompensationsRequestLoadingMain({
            loading: false,
            success: false,
          })
        );
        yield put(actions.setGridSizeValidateMain(false));
      }
    }
  );
}

export default function* compensationsSaga() {
  yield all([fork(getRemunerationsDashbord), fork(sendRequestReturnedMain)]);
}
